// extracted by mini-css-extract-plugin
module.exports = {"header":"Chat--GoalsList-module_header-23nwy"};